import { render, staticRenderFns } from "./QuestionImage.vue?vue&type=template&id=2d24cee2&scoped=true"
import script from "./QuestionImage.vue?vue&type=script&lang=js"
export * from "./QuestionImage.vue?vue&type=script&lang=js"
import style0 from "./QuestionImage.vue?vue&type=style&index=0&id=2d24cee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d24cee2",
  null
  
)

export default component.exports